// @ts-check
import './status.scss';
import { h } from 'preact';

/**
 * @param {object} props
 * @param {string} props.label
 * @param {import('../../../../types').StatusValue} props.value
 */
export default function Status({ label, value }) {
	return (
		<div className={`status-container status-${value}`}>
			<label className="status-label">{label}</label>
		</div>
	);
}
